export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Helper function to include authorization token in requests
const getHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'X-Client': 'portal'
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`; // Or whatever your backend expects
  }
  return headers;
};

export const fetchClientStores = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/v3/storeinfo/getClientStores`, {
      method: 'GET',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

//CRUD API calls
export const fetchOfferData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/seller/offer/getClientWiseOffers`, {
      method: 'GET',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const createOffer = async (itemData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/seller/offer`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(itemData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating offer:', error);
    throw error;
  }
};

export const updateOffer = async (offerId, offerData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/seller/offer/${offerId}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(offerData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating offer:', error);
    throw error;
  }
};

export const deleteOffer = async (offerId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/seller/offer/${offerId}`, {
      method: 'DELETE',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // No content expected in successful DELETE responses
    return;
  } catch (error) {
    console.error('Error deleting offer:', error);
    throw error;
  }
};

// Config API calls

export const saveConfiguration = async (formData) => {
  console.log('api called');
  try {
    const response = await fetch(`${API_BASE_URL}/v3/receipt-conf`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Important:  No Content-Type header here!  Let the browser set it for FormData
        'X-Client' : 'portal'
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error saving configuration:', error);
    throw error;
  }
};

export const fetchConfiguration = async () => {
  try {
      const response = await fetch(`${API_BASE_URL}/v3/receipt-conf`, { // Your backend endpoint
          method: 'GET',
          headers: getHeaders(),
      });

      if (!response.ok) {
          throw new Error(`Failed to fetch configuration: ${response.status}`);
      }

      const data = await response.json();
      return data;
  } catch (error) {
      console.error('Error fetching configuration:', error);
      throw error;
  }
};

export const uploadFile = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(`${API_BASE_URL}/upload`, {  // Assuming an /upload endpoint
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`  // Important:  No Content-Type header here!  Let the browser set it for FormData
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`File upload failed with status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
    }
};
// ... (Existing code)

export const login = async (username, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/auth/login`, {  // Replace with your actual login endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Client' : 'portal'
      },
      body: JSON.stringify({  // Construct the request body
        data: {
          username: username,
          password: password,
          role: "SELLER", //Hard coded the type since it does not change
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Login failed with status: ${response.status}`);
    }

    const data = await response.json();
    return data;  // Expecting { token: "your_token" }
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};
// export const forgotPassword = async (email) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/v2/forget_password/otp`, { // Replace with your actual endpoint
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({  // Construct the request body
//         data: {
//           username: username,
//           password: password,
//           role: "SELLER", //Hard coded the type since it does not change
//         },
//       }),
//     });

//     if (!response.ok) {
//       throw new Error(`Forgot password request failed: ${response.status}`);
//     }

//     return await response.json(); // Or handle as needed
//   } catch (error) {
//     console.error('Forgot password error:', error);
//     throw error;
//   }
// };

export const requestOtp = async (email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/forget_password/otp`, { // Replace with your actual endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Client' : 'portal'
      },
      body: JSON.stringify({  // Construct the request body
        data: {
          username: email,
          role: "SELLER", //Hard coded the type since it does not change
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Request OTP failed: ${response.status}`);
    }

    return await response.json(); // Or handle as needed
  } catch (error) {
    console.error('Request OTP error:', error);
    throw error;
  }
};

export const verifyOtpAndResetPassword = async (email, otp, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/forget_password`, { // Replace with your actual endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Client' : 'portal'
      },
      body: JSON.stringify({  // Construct the request body
        data: {
          username: email,
          otp:otp,
          password:password,
          confirm_password:password,
          role: "SELLER", //Hard coded the type since it does not change
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Verify OTP and reset password failed: ${response.status}`);
    }

    return await response.json(); // Or handle as needed
  } catch (error) {
    console.error('Verify OTP and reset password error:', error);
    throw error;
  }
};

export const changePassword = async (currentPassword, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v2/change_password`, { // Replace with your actual endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('token')}`,
         'X-Client' : 'portal'
      },
      body: JSON.stringify({  // Construct the request body
        data: {
          existingPassword:currentPassword,
          newPassword: password,
          confirm_password: password
        },
      })
    });

    if (!response.ok) {
      throw new Error(`Change password request failed: ${response.status}`);
    }

    return await response.json(); // Or handle as needed
  } catch (error) {
    console.error('Change password error:', error);
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('token'); //Remove token
  //SecureCookie.remove('token', { path: '/' });  // Remove cookie if using cookies
};
export const fetchLocations = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/v3/storeinfo?search=`, {
      method: 'GET',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data; // Assuming backend returns { code: 0, data: [...] }
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
};



export const createLocation = async (locationData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v3/storeinfo`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(locationData), // Payload includes { data: {...} }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data; // Assuming backend returns the created item, e.g., { data: {...} }
  } catch (error) {
    console.error('Error creating location:', error);
    throw error;
  }
};

export const updateLocation = async (locationId, locationData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v3/storeinfo/${locationId}`, { // Assuming update uses ID in URL
      method: 'PUT', // Or PATCH, depending on your API
      headers: getHeaders(),
      body: JSON.stringify(locationData), // Payload includes { data: {...} }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data; // Assuming backend returns the updated item
  } catch (error) {
    console.error('Error updating location:', error);
    throw error;
  }
};

export const deleteLocation = async (locationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v3/storeinfo/${locationId}`, { // Assuming delete uses ID in URL
      method: 'DELETE',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // No content expected in successful DELETE responses, or handle as needed
    return;
  } catch (error) {
    console.error('Error deleting location:', error);
    throw error;
  }
};

export const fetchFormConfig = async () => {
  try {
    // const response = await axios.get(`${API_BASE_URL}/v3/receipt-conf`);
    // return response.data; // Assuming the response is in the shape you provided earlier


    const response = await fetch(`${API_BASE_URL}/v3/receipt-conf`, {
      method: 'GET',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data; // Assuming backend returns { code: 0, data: [...] }


  } catch (error) {
    throw new Error('Failed to fetch form configuration');
  }
};

// Submit the form data
export const submitFormData = async (formData) => {
  try {
    // const response = await axios.post(`${API_BASE_URL}/submit-form`, {
    //   data: formData
    // });

     const response = await fetch(`${API_BASE_URL}/v3/genreceiptinfo`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Important:  No Content-Type header here!  Let the browser set it for FormData
        'X-Client' : 'portal',
        'X-API-KEY' :"00957cd3cfcb4fc199ac6304ca76b586f3d0e0bd3b4e404c8a50eba54b74392f",
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData), // Payload includes { data: {...} }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data; // Assuming backend returns the created item, e.g., { data: {...} }

    //return response.data;  // Assuming the response contains success message or status
  } catch (error) {
    throw new Error('Failed to submit form data');
  }
};
export const fetchReceipts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/v3/genreceiptinfo`, {
      method: 'GET',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data; // Assuming backend returns { code: 0, data: [...] }
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
};
// --- Software Downloads API Call (Updated from Mock) ---
export const fetchSoftwareVersions = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/admin/list`, { // ** CHANGE THIS to your actual endpoint **
            method: 'GET',
            headers: getHeaders(),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data; // Assumes the backend returns the same structure: { code: 0, data: [...] }
    } catch (error) {
        throw error; // Re-throw the error so the component can catch it
    }
};

export const downloadSoftware = async (version) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/admin/download/${version.id}`, { // Your backend endpoint
            method: 'GET',
            headers: getHeaders(), // This function already adds your 'Authorization' header
        });

        if (!response.ok) {
            // If the server returns a JSON error, we can try to parse it
            if (response.headers.get('content-type')?.includes('application/json')) {
                const errorData = await response.json();
                throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
            }
            // Otherwise, throw a generic error
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Get the filename from the Content-Disposition header if available, otherwise use the requested name
        const disposition = response.headers.get('Content-Disposition');
        let downloadFilename = version.fileName;
        if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                downloadFilename = matches[1].replace(/['"]/g, '');
            }
        }

        // Convert the response body to a Blob
        const blob = await response.blob();
        
        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);
        
        // Create a temporary anchor element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = downloadFilename; // Use the filename from the header or the one passed to the function
        document.body.appendChild(a); // Append to the body
        a.click(); // Programmatically click the link to trigger the download
        
        // Clean up: remove the anchor and revoke the URL
        a.remove();
        window.URL.revokeObjectURL(url);

    } catch (error) {
        // You can re-throw the error to be handled by the component
        throw error;
    }
};

export const deleteReceipts = async (receiptId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v3/genreceiptinfo${receiptId}`, { // Assuming delete uses ID in URL
      method: 'DELETE',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // No content expected in successful DELETE responses, or handle as needed
    return;
  } catch (error) {
    console.error('Error deleting location:', error);
    throw error;
  }
};